<template>
  <BaseModal
    ref="baseModalRef"
    :title="'Planes de Misión'"
    modal-id="missions"
    :isVisible="true"
    @close="closeDialog"
    @minimize="$emit('minimize', 'missions')"
    @restore="$emit('restore', 'missions')"
  >
    <div id="buscador" class="form">
      <div class="container-fluid">
        <div class="form events-window">
          <h5 class="col-12 ml-0">
            <div class="filters-show" @click="toggleFilters" style="cursor: pointer">
              <i :class="showFilters ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
              <i class="bi bi-funnel"></i> Filtrar
            </div>
          </h5>

          <!-- INICIO FILTROS -->
          <div v-if="showFilters" class="row filter-box col-12">
            <div class="col-4 col-6-small">
              <!-- Generico fechas -->
              <div class="filter-group">
                <div class="form-check">
                  <select
                    class="form-select select-tiempo form-select-sm"
                    aria-label="Default select example"
                    @change="handleGenericDateChange"
                  >
                    <option selected>Siempre</option>
                    <option value="1">Hoy</option>
                    <option value="2">Este mes</option>
                    <option value="3">Este año</option>
                    <option value="4">Ultimos 7 dias</option>
                    <option value="5">Ultimos 15 dias</option>
                    <option value="6">Ultimos 30 dias</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-4 col-6-small">
              <!-- FECHA DESDE -->
              <div class="filter-group">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="showStartDate"
                    v-model="filters.showStartDate"
                    @change="callApi"
                  />
                  <label class="form-check-label" for="flexCheckDefault"> Desde </label>
                </div>
                <div v-if="filters.showStartDate" class="active-filter">
                  <input
                    type="date"
                    v-model="filters.start_date"
                    @change="callApi"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="col-4 col-6-small">
              <!-- FECHA HASTA -->
              <div class="filter-group">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="showEndDate"
                    v-model="filters.showEndDate"
                    @change="callApi"
                  />
                  <label class="form-check-label" for="flexCheckDefault"> Hasta </label>
                </div>
                <div v-if="filters.showEndDate" class="active-filter">
                  <input
                    type="date"
                    v-model="filters.end_date"
                    @change="callApi"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row list-box">
          <div class="col-list">
            <div class="text-center">
              <label
                >Misiones Filtradas <span>({{ cantidadMissionPlan }})</span></label
              >
            </div>
            <div class="missions-list" style="height: 100%">
              <div v-for="group in groupedMissions" :key="group.missionNumber">
                <div
                  class="missions-list-group"
                  style="font-weight: bold; padding: 4px 0; cursor: pointer"
                  @click="toggleGroup(group.missionNumber)"
                >
                  Misión {{ group.missionNumber }}
                  <span style="font-size: 10px; margin-left: 8px">
                    <template v-if="expandedGroups[group.missionNumber]">▼</template>
                    <template v-else>►</template>
                  </span>
                </div>
                <div v-if="expandedGroups[group.missionNumber]">
                  <div
                    v-for="mission in group.missions"
                    :key="mission.plan_id"
                    @click.stop="toggleMission(mission.plan_id)"
                    class="missions-list-item"
                    :class="{
                      selected:
                        selectedMissionPlan && selectedMissionPlan.plan_id === mission.plan_id
                    }"
                    style="padding-left: 18px"
                    @click="changeMission(mission)"
                  >
                    {{ mission.name }} - {{ formatUtc(mission.utc) }}
                    <div
                      v-if="expandedMission === mission.plan_id"
                      class="mission-details"
                      style="margin-top: 4px; font-size: 12px; color: #444"
                    >
                      <div><b>Destino:</b> {{ mission.dest_unit }}</div>
                      <div><b>Usuario:</b> {{ mission.user_name }}</div>
                      <div><b>Recibido:</b> {{ mission.received }}</div>
                      <div><b>Unidad fuente:</b> {{ mission.source_unit }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="datos-report">
            <div v-if="missionEvents && missionEvents.length > 0">
              <div class="event-list">
                <div v-for="evt in missionEvents" :key="evt.event_id" class="event-row">
                  <div class="event-img">
                    <img
                      :src="'/images/event_type_' + getTypeId(evt.type) + '.png'"
                      :alt="evt.type"
                      class="event-icon"
                    />
                  </div>
                  <div class="event-info">
                    <div class="event-id">
                      <b>ID:</b> {{ evt.event_unit }} {{ evt.event_number }}
                    </div>
                    <div class="event-type"><b>Tipo:</b> {{ evt.type }}</div>
                    <div class="event-date"><b>Fecha:</b> {{ formatUtc(evt.utc) }}</div>
                    <div class="event-coords">
                      <b>Lat:</b> {{ evt.location?.coordinates?.[1]?.toFixed(6) ?? '' }},
                      <b>Lon:</b> {{ evt.location?.coordinates?.[0]?.toFixed(6) ?? '' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <em>No hay eventos para esta misión.</em>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script setup lang="ts">
import { ref, defineEmits, onMounted, computed } from 'vue'
import BaseModal from './base/BaseModal.vue'
import FiltroFechas from './base/FiltroFechas.vue'
import type { MissionPlan, Evento } from '../types'
import API from '../services'
import { AxiosError } from 'axios'
import { useGlobalStore } from '../stores/global'
import { useServicesStore } from '@/stores/services'
import { storeToRefs } from 'pinia'
import { useUtils } from '@/composables/useUtils'

const { formatUtc } = useUtils()

const global = useGlobalStore()
const { missionPlan, missionEvents } = storeToRefs(global)

const serv = useServicesStore()
const { eventTypes } = storeToRefs(serv)

const missionPlanList = ref<MissionPlan[]>([])
const cantidadMissionPlan = ref(0)
const selectedMissionPlan = ref<MissionPlan | null>(null)
const startDate = ref<string>('')
const endDate = ref<string>('')

const groupedMissions = computed(() => {
  console.log(
    '📋 Datos originales:',
    missionPlanList.value.map((m) => m.mission)
  )

  // Agrupar
  const groups: Record<string, MissionPlan[]> = {}
  missionPlanList.value.forEach((mission) => {
    if (!groups[mission.mission]) {
      groups[mission.mission] = []
    }
    groups[mission.mission].push(mission)
  })

  // Ordenar dentro de cada grupo por UTC DESC
  Object.values(groups).forEach((plans) => {
    plans.sort((a, b) => new Date(b.utc).getTime() - new Date(a.utc).getTime())
  })

  // En lugar de retornar objeto, retornar array ordenado
  const sortedGroups = Object.entries(groups)
    .sort(([a], [b]) => Number(b) - Number(a)) // DESC
    .map(([missionNumber, missions]) => ({
      missionNumber,
      missions
    }))

  console.log(
    '🔄 Grupos ordenados:',
    sortedGroups.map((g) => g.missionNumber)
  )
  return sortedGroups
})

const showFilters = ref(false) // Controla la visibilidad de filter-box
const expandedMission = ref<string | null>(null)
const baseModalRef = ref()

defineExpose({
  restoreModal: () => {
    if (baseModalRef.value) {
      baseModalRef.value.restoreModal()
    }
  }
})

function toggleMission(missionId: string) {
  expandedMission.value = expandedMission.value === missionId ? null : missionId
}
const expandedGroups = ref<Record<string, boolean>>({})
function toggleGroup(missionNumber: string) {
  expandedGroups.value[missionNumber] = !expandedGroups.value[missionNumber]
}

const filters = ref({
  showStartDate: false,
  showEndDate: false,
  start_date: '',
  end_date: ''
})

const emit = defineEmits<{
  (event: 'closed'): void
  (event: 'minimize', modalId: string): void
  (event: 'restore', modalId: string): void
}>()
function closeDialog() {
  emit('closed')
}

function toggleFilters() {
  showFilters.value = !showFilters.value
}

function handleGenericDateChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value
  const today = new Date()
  let startDate = ''
  let endDate = today.toISOString().slice(0, 10) // formato YYYY-MM-DD

  switch (value) {
    case '1': // Hoy
      startDate = endDate
      break
    case '2': // Este mes
      startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10)
      break
    case '3': // Este año
      startDate = new Date(today.getFullYear(), 0, 1).toISOString().slice(0, 10)
      break
    case '4': // Últimos 7 días
      startDate = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    case '5': // Últimos 15 días
      startDate = new Date(today.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    case '6': // Últimos 30 días
      startDate = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    default:
      // Siempre: limpiar fechas y ocultar
      filters.value.showStartDate = false
      filters.value.showEndDate = false
      filters.value.start_date = ''
      filters.value.end_date = ''
      callApi()
      return
  }

  filters.value.showStartDate = true
  filters.value.showEndDate = true
  filters.value.start_date = startDate
  filters.value.end_date = endDate
  callApi()
}
async function changeMission(mission: MissionPlan) {
  selectedMissionPlan.value = mission
  getMissionPlan(mission.plan_id)
  missionEvents.value = await getMissionEvents(mission.mission)
}
async function getMissionEvents(missionId: string): Promise<Evento[]> {
  const filter: Record<string, string> = { mission: missionId }

  try {
    const { status, data } = await API.getEvents(filter)
    if (status === 200) {
      const evt = data.Entries
      const temp: Evento[] = Array.isArray(evt.Entry) ? evt.Entry : [evt.Entry]
      return temp
    } else {
      return []
    }
  } catch (error) {
    // En caso de error, retornar un array vacío
    return []
  }
}
function getTypeId(type: string) {
  let tipoEvento = eventTypes.value.find((tipo) => tipo.event_type === type)

  return tipoEvento ? tipoEvento.event_type_id : 5
}
onMounted(() => {
  callApi()
})
async function callApi() {
  const filters = {
    start_date: startDate.value.replace(/-/g, ''),
    end_date: endDate.value.replace(/-/g, '')
  }
  try {
    const { status, data } = await API.listMissionPlans(filters)

    if (status == 200) {
      missionPlanList.value = data.Entries.Entry
      cantidadMissionPlan.value = missionPlanList.value.length
    } else {
      missionPlanList.value = []
      cantidadMissionPlan.value = 0
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
    missionPlanList.value = []
    cantidadMissionPlan.value = 0
  }
}
async function getMissionPlan(plan_id: string) {
  try {
    const { status, data } = await API.getMissionPlan(plan_id)
    if (status == 200) {
      missionPlan.value = data
    } else {
      missionPlan.value = null
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
    missionPlan.value = null
  }
}
</script>

<style lang="css" scoped>
input,
.form-select label {
  max-width: 100%;
}

.table-wrapper {
  overflow-y: scroll;
  height: 80vh;
}

.modal-container {
  min-width: 490px;
  width: 500px;
  height: 450px;
  min-height: 330px;
  max-height: 85vh;
}

.form-select {
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  scrollbar-color: white rgba(255, 255, 255, 0.3);
  max-height: 100%;
}

.row,
.col-10 {
  padding-right: 0%;
  justify-content: space-evenly;
}

h5 {
  height: max-content;
}

input,
.form-select label {
  max-width: 100%;
}

input.form-text-input,
input.form-number-input,
label.form-text-label {
  font-size: 12px;
}

.form,
.container-fluid,
.col-2,
.col-5 {
  height: 100%;
}

.missions-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  scrollbar-color: white rgba(255, 255, 255, 0.3);
  max-height: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.missions-list-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}

.missions-list-item.selected {
  background: rgba(255, 255, 255, 0.3);
  color: black;
  font-weight: bold;
  border-radius: 5px;
}

.missions-list-item:hover {
  background: #f5f5f5;
}

.mission-details {
  background: #ffffff;
  border-radius: 3px;
  padding: 6px 10px;
  margin-left: -10px;
  margin-right: 10px;
  margin-bottom: 4px;
}

.datos-report .event-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.event-row {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  padding: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.event-img {
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.event-icon {
  width: 32px;
  height: 32px;
}

.event-info {
  flex: 1 1 0;
  margin-left: 10px;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #333;
  /* <-- Añade esto */
}

.event-info b {
  color: #222;
  /* Opcional: mejora el contraste de los títulos */
}

.event-coords {
  color: #2d5c8a;
  /* Opcional: color diferente para lat/lon */
}

@media (max-width: 600px) {
  .event-row {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 6px;
  }

  .event-info {
    margin-left: 0;
    font-size: 12px;
  }
}

.events-window {
  margin: 0px 10px;
  margin-top: 0px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  width: 100%;
  height: max-content;
}
@media (max-width: 576px) {
  .modal-container-small {
    max-width: 90vw;
    min-width: 200px;
    width: 90vw;
    height: 480px;
    min-height: 400px;
  }

  .col-2 {
    height: fit-content;
  }

  .col-3 {
    height: 200px;
  }

  .col-5 {
    width: 100%;
    margin-top: 30px;
  }
}

.filter-box .form-check {
  display: inline-block;
  width: auto;
  margin-right: 10px;
  min-height: fit-content;
}
.filter-box {
  border: 0px solid white;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 12px;
  padding: 5px;
  margin: 0;
}

.fltr-btn {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.active-filter {
  padding: 2px;
  border: 1px solid #6c757d;
  /* Borde azul */
  border-radius: 10px;
}

.filters-show {
  text-decoration: underline;
  margin-top: 10px;
}

.filters-show:hover {
  color: #6c757d;
  text-decoration: none;
  cursor: pointer;
}

.list-box {
  height: calc(100% - 60px);
}
</style>
